var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveCasinoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2765_4189)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9 19.581a9.64 9.64 0 002.349 2.08c.268.167.545.322.83.463l-.968 1.08-.082.09-.105.06c-.314.18-1.054.45-1.817.035l-.152-.093c-.44-.294-.702-.646-.838-1.01l-.05-.158a2.114 2.114 0 01.003-1.067l.028-.103.052-.092.75-1.285zM15.354 5.877A9.57 9.57 0 0022.843 12a4.83 4.83 0 01-3.162 1.651l-6.553 7.305a8.039 8.039 0 01-.848-.426l-.234-.14a8.104 8.104 0 01-1.138-.864l-.342-.329a8.116 8.116 0 01-.847-1.02l4.765-8.172a4.847 4.847 0 01.871-4.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.549 2a1 1 0 011 1v2.936a6.31 6.31 0 00-.642 3.798l-5.283 9.063H3a1 1 0 01-1-1V3a1 1 0 011-1h9.549zM8 7.614c-.145-.152-.347-.152-.5 0-.153.153-1.516 1.583-1.516 1.583l-.023.026c-.243.263-.71.77-.711 1.41 0 .789.563 1.445 1.375 1.445.197 0 .372-.033.528-.092l-.36 1.514H8.71l-.363-1.526c.17.067.35.104.528.104.813 0 1.375-.656 1.375-1.444 0-.657-.492-1.18-.75-1.445L8 7.614z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.186 4a4.84 4.84 0 014.506 6.587 8.06 8.06 0 01-7.122-5.822A4.817 4.817 0 0119.186 4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2765_4189"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
SvgLiveCasinoFilled.displayName = 'LiveCasinoFilled';
export default SvgLiveCasinoFilled;